export const CONTACT_INFO = {
        name: "Gregg Johnson",
        title: "Software Engineering Manager",
        email: "grjohnson@gmail.com",
        phone: "720-217-9463",
        linkedIn: {
            url: "https://www.linkedin.com/in/gregg-johnson-3011194",
            text: "in/gregg-johnson-3011194"
        },
        gitHub: {
            url: "https://github.com/grjohnson1",
            text: "grjohnson1"
        },
        siteName: {
            url: "https://dochano.com",
            text: "dochano.com"
        }
    };

export const EXPERIENCE_INFO = [
        {
            position: "Software Engineering Manager",
            startDate: "2022-02-28",
            endDate: "2024-12-15",
            companyName: "Communify Fincentric",
            formerInfo: { "name": "S&P Global", transitionDate: "2022-02-28" },
            list: [
                "Team Leadership: Scheduled weekly one-on-one goal-setting sessions with a seven-member, multi-time-zone team to enhance accountability and ensure timely project delivery.",
                "Strength Builder: Increased team throughput by 25% by establishing transparent and realistic timelines that encouraged mutual accountability.",
                //"Agile Evangelist: Acted as Scrum Master—leading sprint planning, stand-ups, velocity reviews, and retrospectives to drive efficient website development processes."
                "Compliance Leadership: Managed annual regulatory renewals (Sarbanes-Oxley Act - SOX, European Union's General Data Protection Regulation - GDPR, Web Accessibility - A11y), guaranteeing that digital touchpoints met stringent security, privacy, and accessibility standards.",
                "Epic Envisioning: Collaborated with cross-functional teams (i.e. Product and Design) to define project timelines, prioritize deliverables, and identify blockers to clients' delight, resulting in additional contracts."
            ]
        },
        {
            position: "Software Engineering Manager",
            startDate: "2011-06-01",
            endDate: "2022-02-28",
            companyName: "Communify Fincentric",
            formerInfo: { "name": "IHS Markit", transitionDate: "2012-06-12" },
            list:  [
                /*"Efficient Onboarding"*/"Accelerated Integration: Improved engineering documentation processes, enabling new developers to contribute within days rather than weeks, crucial for rapid website development.",
                "Team Coach: Mentored engineers transitioning into leadership roles, fostering career development and succession planning within the organization.",
                //"Technical Certification: Established a company-sponsored certification program in HTML5, JavaScript, and CSS3 to enhance web development standards across projects.",
                 "Client Satisfaction: Executed a comprehensive business strategy involving a large migration of user portfolios for high-profile clients with roughly 10,000 users from external source to internal SQL database, resulting in additional statements of work (SOW).",
                "API Development: Curated template strategies to aid documentation support of high-demand APIs, similar to Quote API, to assist in scalability, reusability, and maintainability."
            ]
        },
        {
            position: "Software Engineering Technical Lead",
            startDate: "2006-06-01",
            endDate: "2011-06-01",
            companyName: "Communify Fincentric",
            formerInfo: { "name": "Markit", transitionDate: "2010-06-09" },
            list: [
                "Technical Leadership: Conducted code reviews to enforce coding standards, ensuring scalable and maintainable website components.",
                //"Hiring Management: Enhanced prospective hire coding challenge to identify the web developer's experience level.",
                "Flexible Ingenuity: Innovative implementation of unique hash key for retrieving questionnaire answers year over year, which decreased development time by over 50%.",
                "User Experience (UX) Optimization: Customized financial services websites with AI tools to better present complex data, aligning digital experiences with user needs.",
                "Cloud Technology: Utilized technical experience to create a migration plan by removing project dependency and version latency to transition to cloud computing.",
            ]
        },
        {
            position: "Senior Software Engineer",
            startDate: "2004-08-01",
            endDate: "2006-06-01",
            companyName: "Communify Fincentric",
            formerInfo: { "name": "Wall Street On Demand" },
            list: [
                "Machine Learning Knowledge: Customized financial services websites with ML tools to help users understand complex financial data with internal branching models and event based weighted models.",
                "Cross-team Ambassador: Acted as liaison between front-end development teams to share document management skills and techniques.",
                "Educator: Crafted and led training sessions to equip developers with proficiency in logging and performance tracking tools like Grafana and Kibana, ensuring readiness for live production incidents.",
                //"Efficiency Crusader: Streamlined production release process to under five minutes for full stack application updates."
            ]
        },
        {
            position: "Software Engineer",
            startDate: "2000-08-01",
            endDate: "2004-08-01",
            companyName: "Communify Fincentric",
            formerInfo: { "name": "Wall Street On Demand" },
            list: [
                "Optimization Excellence: Reduced critical page performance from 1 second to under 10 milliseconds load time.",
                //"Microsoft Technology Stack: Created and maintained .NET sites that securely utilized Microsoft SQL Server queries for multiple large financial research sites requiring real-time and accurate stock quote data.",
                "Full Stack Development: Experienced data management of variety of documents (i.e. PDF, XML, images, and videos) from CMS tools to be available via APIs or sent to users through SMS or email.",
                "Frontend Experience: Evolved award-winning User Interface (UI) maturity with mastery of JavaScript in developing advanced screeners and interactive charts for varying securities.",
                //"Innovation Exposure: Pioneered front-end web development for Pocket PC at a financial firm, providing complimentary devices to clients with over $1 million in trades."
            ]
        }
    ];

export const SKILLS = [
        "Full Stack Web Developer",
        "Software Development Life Cycle (SDLC)",
        "Software as a Service (SAAS)",
        "Problem Solver", 
        "Product Management",
        "Agile Development",
        "Software Architect",
        "React",
        "Node",
        "Accessibility",
        //"Automated Testing",
        //"Unit Testing",
        "Quality Assurance",
        "Analytics Tools",
        "SQL",
        //"SAML",
        //"JWT",
        "Python",
        "TypeScript",
        "JavaScript",
        ".NET",
        "Cloud Computing",
        "ASP Classic",
        "Github",
        "Jira",
        "Figma",
        "Ping Federate",
        "VS Code",
        "Grafana",
        "Confluence",
        "Microsoft Suite",
        "PowerPoint",
        "Excel",
        "Staff Sentry",
        "Visionary Supporter",
        "Documentation Specialist",
        "Organized Career Mentor",
        "Carpool Decompressionist",
        "Veteran Parent Traveler"
    ];

export const ABOUT = [
    "Results-driven Engineering Manager with a strong background in coding excellence, enhancing collaboration, and driving process efficiency. Adept at maintaining cross-functional teams, leading complex migration strategies, and improving customer satisfaction through effective communication. Passionate about continuous improvement, innovation, and championing team member growth."
    //"staff sentry", "visionary supporter", "zealous documentation specialist", "organized career mentor", "carpool decompression enthusiast", "veteran parent traveler"
    ];

export const EDUCATION = [
        {
            school: "Metropolitan State University of Denver",
            degree: "Bachelor of Science",
            program: "Computer Information Systems",
            endDate: new Date(2000, 4, 13)
        }
    ];

export const CERTIFICATES = [
        /*{
            topic: "React - The Complete Guide 2025 (includes Next.js, Redux)",
            sponsor: "Udemy"
        },*/
        {
            topic: "Python Playground (Second Edition)",
            sponsor: "No Starch Press",
            endDate: new Date(2025, 6, 7)
        },
        {
            topic: "Artificial Intelligence for Developers (includes Python, TensorFlow.js)",
            sponsor: "In Easy Steps Ltd.",
            endDate: new Date(2025, 5, 11)
        },
        {
            topic: "Headless CMS development",
            sponsor: "Sanity.io",
            endDate: new Date(2025, 5, 11)
        },
        {
            topic: "Programming in HTML5 with JavaScript and CSS3",
            sponsor: "Microsoft",
            certification: true,
            endDate: new Date(2014, 5, 15)
        }
    ];